// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PlanningModal_selected__13_gG {\n  color: #fff;\n  background: var(--background-creneau-normal);\n}\n", "",{"version":3,"sources":["webpack://src/Components/Planning/PlanningModal.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,4CAA4C;AAC9C","sourcesContent":[".selected {\n  color: #fff;\n  background: var(--background-creneau-normal);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selected": "PlanningModal_selected__13_gG"
};
export default ___CSS_LOADER_EXPORT___;
